/**
 * Export Service Types
 *
 * Type definitions for data export API operations.
 */

/**
 * Error thrown by export API operations
 */
export class ExportApiError extends Error {
  constructor(
    message: string,
    public readonly statusCode: number
  ) {
    super(message);
    this.name = 'ExportApiError';
  }
}

/**
 * Export format options
 */
export type ExportFormat = 'csv' | 'xlsx' | 'json';

/**
 * Export type - alerts or products
 */
export type ExportType = 'alerts' | 'products';

/**
 * Parameters for export request
 */
export interface ExportParams {
  type: ExportType;
  format: ExportFormat;
  fields?: string[];
  tab?: number;
}

/**
 * Result from export operation
 */
export interface ExportResult {
  blob: Blob;
  filename: string;
}

/**
 * Export field options
 */
export const EXPORT_FIELD_OPTIONS = {
  product: 'Product',
  status: 'Status',
  stock: 'Stock Level',
  threshold: 'Threshold',
  date: 'Date',
  velocity: 'Velocity',
  sku: 'SKU',
  variant: 'Variant',
} as const;

/**
 * Default export fields
 */
export const DEFAULT_EXPORT_FIELDS = ['product', 'status', 'stock', 'threshold', 'date'];
